import { useState, useEffect } from "react";
import { TrendingUp, ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

// "What Changed" Ticker — rotates through dynamic metric changes
export const WhatChangedTicker = ({ changes }) => {
  const [currentIdx, setCurrentIdx] = useState(0);

  useEffect(() => {
    if (changes.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIdx((prev) => (prev + 1) % changes.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [changes.length]);

  if (!changes || changes.length === 0) return null;
  const c = changes[currentIdx];
  const isUp = c.change_pct > 0;
  const isFlat = Math.abs(c.change_pct) < 1;

  const trendColor = isFlat ? "text-muted-foreground" : isUp ? "text-emerald-400" : "text-red-400";

  return (
    <div
      className="bg-gradient-to-r from-emerald-500/[0.06] to-cyan-500/[0.04] border border-emerald-500/20 rounded-xl px-3 md:px-5 py-3 md:py-4 flex items-center gap-2 md:gap-4 overflow-hidden"
      data-testid="what-changed-ticker"
    >
      <div className="flex items-center gap-2 flex-shrink-0">
        <div className="w-7 h-7 rounded-lg bg-emerald-500/15 flex items-center justify-center">
          <TrendingUp className="w-4 h-4 text-emerald-400" />
        </div>
        <span className="text-xs font-semibold text-emerald-400/80 uppercase tracking-wide">What Changed</span>
      </div>
      <div className="flex-1 flex items-center gap-4 overflow-hidden">
        <span className="text-sm md:text-base font-semibold whitespace-nowrap">{c.metric}</span>
        <div className="flex items-center gap-1.5">
          {isFlat && <Minus className="w-4 h-4 text-muted-foreground" />}
          {!isFlat && isUp && <ArrowUpRight className="w-4 h-4 text-emerald-400" />}
          {!isFlat && !isUp && <ArrowDownRight className="w-4 h-4 text-red-400" />}
          <span className={`text-base md:text-lg font-bold tabular-nums ${trendColor}`}>
            {c.change_pct > 0 ? "+" : ""}{c.change_pct}%
          </span>
        </div>
        <span className="text-xs md:text-sm text-slate-400 whitespace-nowrap hidden sm:inline">
          {c.prior.toLocaleString()} → {c.recent.toLocaleString()}{" "}
          <span className="text-slate-400">(last 3 mo vs prior 3)</span>
        </span>
      </div>
      <div className="flex gap-1.5">
        {changes.map((_, i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full transition-all ${i === currentIdx ? "bg-emerald-400 w-4" : "bg-muted-foreground/30"}`}
          />
        ))}
      </div>
    </div>
  );
};

export default WhatChangedTicker;
